<script setup>
import Layout from '../../Components/Shared/Layout.vue'
import { Link } from '@inertiajs/inertia-vue3'
import ButtonComponent from '../../Components/Shared/ButtonComponent.vue';
import HarvestCollection from '../../Components/Portfolio/HarvestCollection.vue';
import Map from '../../Components/Map/Map.vue'
import MapAreaShow from '../../Components/Map/MapAreaShow.vue'
import { Inertia } from '@inertiajs/inertia'
import useApi from '../../Services/useApi';
import useNotification from '../../Services/useNotification';

const props = defineProps(["farm","harvests","fruits","area"])
const api = useApi();
const notificate = useNotification();
const trees = props.harvests.map(item=>item.trees)
let trees_locations = []
if(trees[0]) trees_locations = trees[0].map(item=>[item.lon,item.lat])
const area_locations = props.area.map(item=>[item.lon,item.lat])
const harvests_areas_locations = props.harvests.map(item=>item.area.map(i=>[i.lon,i.lat]))
const all_areas = [area_locations,...harvests_areas_locations]
console.log(all_areas);
const deleteFarm = () => {
    notificate.confirm(`Eliminar ${props.farm.name} tambien eliminara sus cosechas y arboles. Esta accion no se puede deshacer.`, () => {
        api.deleteFarm(props.farm).then(() => {
            notificate.success("Finca eliminada");
            Inertia.visit('/portfolio');
        }).catch(() => {
            notificate.error("No fue posible eliminar la finca");
        });
    });
};

</script>
<template lang="">
    <layout>
        <div class="container pt-5 mx-auto">
            <div >
                <div >
                    <ButtonComponent 
                        content="Atrás" 
                        :icon="'arrow_back_ios'"
                        :link="'/portfolio'"
                        type="2"
                    />
                    <div class="flex flex-col justify-between w-full gap-3 sm:flex-row sm:items-center">
                        <h2 class="text-enriqueto_green">{{farm.name}}</h2>
                        <div class="flex flex-wrap items-center">
                            <ButtonComponent 
                                content="Nueva cosecha" 
                                :icon="'add'"
                                :link="'/portfolio/farm/'+farm.id+'/harvest/create'"
                                :normalLink="true"
                                :newWindow="true"
                                type="0"
                                />
                            <button
                                type="button"
                                class="flex items-center px-3 py-2 my-2 text-red-700 border border-red-300 rounded-xl hover:bg-red-50 hover:shadow-md"
                                @click="deleteFarm"
                            >
                                <span class="mr-1 material-symbols-outlined">delete</span>
                                Eliminar finca
                            </button>
                        </div>
                    </div>                          
                    <ButtonComponent 
                    content="Ver Ubicacion" 
                    :icon="'location_on'"
                    :link="'https://www.google.com/maps/@'+farm.lat+','+farm.lon+',15z?hl=es'"
                    :normalLink="true"
                    type="2"
                    />
                    <p>Área: {{farm.size}} {{farm.area_unit === 'ha' ? 'ha' : 'm²'}}</p>
                </div>
                <div >
                    <Map 
                    :center="[farm.lon,farm.lat]" 
                    :locations="trees_locations"
                    locations_icon="crops@2x.png"
                    :locations_area="all_areas"
                    :area="true"
                    :harvest="true"
                    :id="'mapaFinca'"
                    ></Map>
                
                </div>
            </div>
            <HarvestCollection :items="harvests" />
        </div>
    </layout>
</template>
<style lang="">
    
</style>
